import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { reviewListing, viewReview, viewReviewSummary } from "../apis/apiHandler";

export const allReviews = createAsyncThunk(
    'review/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await reviewListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewReviewDetails = createAsyncThunk(
    'review/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewReview(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewReviewsSummary = createAsyncThunk(
    'review/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewReviewSummary(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    reviewList: [],
    error: null,
    reviewDetail: {},
    reviewSum: {}
};

const reviewSlice = createSlice({
    name: 'reviews',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allReviews.pending, (state) => {
                state.loading = true;
            })
            .addCase(allReviews.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.reviewList = payload?.data;
            })
            .addCase(allReviews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(viewReviewDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewReviewDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.reviewDetail = payload?.data;
            })
            .addCase(viewReviewDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(viewReviewsSummary.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewReviewsSummary.fulfilled, (state, action) => {
                state.loading = false;
                state.reviewSum = action.payload;
            })
            .addCase(viewReviewsSummary.rejected, (state, action) => {
                state.loading = false;
                state.reviewSum = action.payload;
            })
    }
})

export default reviewSlice.reducer;